import { ReactNode, useCallback, useEffect, useRef } from 'react'

import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import ThemeProvider from '@mui/material/styles/ThemeProvider'

import { theme } from '../../theme/theme'
import { AppAlerts } from '../AppAlerts/AppAlerts'
import { Navbar } from '../Navbar/Navbar'
import { wrapperService } from './wrapperService'

interface WrapperProps {
    children?: ReactNode
    onScrollToBottom?: () => void
}

export const Wrapper = ({ children }: WrapperProps) => {

    const service = useRef(wrapperService)

    const boxRef = useRef<HTMLElement>()

    const onScroll = useCallback(() => {
        if (boxRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = boxRef.current
            const isNearBottom = scrollTop + clientHeight >= scrollHeight
            if (isNearBottom && service.current.onScrollToBottom) {
                service.current.onScrollToBottom()
            }
        }
    }, [])

    useEffect(() => {
        const boxRefEl = boxRef.current

        if (boxRefEl) {
            boxRefEl.addEventListener('scroll', onScroll)

            return () => {
                boxRefEl.removeEventListener('scroll', onScroll)
            }
        }
    }, [onScroll])

    return (
        <ThemeProvider theme={theme}>
            <Box ref={boxRef} className='wrapper' component='main' sx={{ overflowY: 'auto', height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <CssBaseline />
                <AppAlerts />
                <Navbar />
                <Box sx={{ px: 2, height: '100%' }}>
                    {children}
                </Box>
            </Box>
        </ThemeProvider>
    )
}